export enum PaymentService {
  STRIPE = 'stripe',
  PAYPAL = 'paypal',
  PAYSTACK = 'paystack',
}
